import { INTERNAL_PATHS } from "routes/paths";

export const HOW_IT_WORKS_FAQ = [
  {
    id: 1,
    question: "Are gift cards from GCX plastic or digital?",
    response: (
      <p>
        All of cards are electronic and delivered instantly. Depending on the
        brand, electronic cards may be redeemed online or in store. Double check
        during checkout process to review specific delivery and redemption
        instructions.
      </p>
    )
  },
  {
    id: 2,
    question: "How quickly will my gift cards be delivered?",
    response: (
      <p>
        Most cards are delivered electronically just a few minutes after placing
        your order, but please allow up to 24 hours.
      </p>
    )
  },
  {
    id: 3,
    question: "How do I redeem my gift cards?",
    response: (
      <>
        <p>
          First, log into your GCX account online or download the GCX app to
          access your cards.
        </p>
        <p>
          <ul>
            <li>
              If your card is electronic and you’re shopping online, enter the
              serial number and/or PIN into the gift card section during
              checkout.
            </li>
            <li>
              If your card is electronic and you’re shopping in store, either
              bring the printed voucher or show the barcode and/or serial
              numbers on your phone to the cashier.
            </li>
          </ul>
        </p>
      </>
    )
  },
  {
    id: 4,
    question: "What is GCX Cash?",
    response: (
      <>
        <p>
          GCX Cash is a currency that can be redeemed on any GCX purchase. $1 of
          GCX Cash equals $1 of spending power on our website and mobile app.
        </p>
        <p>
          Buy a GCX Cash Gift Card for yourself, or send one as a gift to earn
          GCX Cash instantly. Select your desired denomination or enter the
          exact amount you’d like to spend to see your earning potential. You
          can also refer friends to earn GCX Cash.
        </p>
        <p>
          GCX Cash is automatically applied for you at checkout. Your order
          total must be greater than the amount of GCX Cash applied.
        </p>
        <p>
          <i>
            Please Note: You cannot redeem promo codes on GCX Cash Gift Cards.
          </i>
        </p>
      </>
    )
  },
  {
    id: 5,
    question: "Who provides the discounted gift cards on GCX?",
    response: (
      <p>
        We source gift cards directly from merchants and from consumers like
        you. Because we are a marketplace, discounts and inventory often
        fluctuate. Shop with confidence knowing every card is backed by our 90
        Day Money-Back Guarantee.
      </p>
    )
  },
  {
    id: 6,
    question: "What is the Money Back Guarantee?",
    response: (
      <p>
        Every card on GCX is backed for 90 days from the date of purchase so you
        can shop with confidence.{" "}
        <a href={INTERNAL_PATHS.GUARANTEE}>Learn More</a>.
      </p>
    )
  }
];
